import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClienteDTO, CodigoDTO, ICodigoDTO, CodigoValorDTO } from "@DTOS";
import { Constants } from "@constants";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class CodigosServiceBackend {
    constructor(private httpClient: HttpClient) {}

    public async getCodigos(): Promise<CodigoDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<ICodigoDTO[]>(`${Constants.apiURL}/customers/4/codes`).pipe(
                map(response => response.map(codigo => new CodigoDTO(codigo)))
            )
        ) ?? [];
    }

    public async agregarCodigo(codigoCrear: CodigoValorDTO, cliente: ClienteDTO): Promise<CodigoDTO> {
        return await firstValueFrom(
            this.httpClient.post<ICodigoDTO>(
                `${Constants.apiURL}/customers/${cliente.id}/codes`, codigoCrear.toJSON()
            ).pipe(
                map(response => new CodigoDTO(response))
            )
        );
    }
}
